export default __webpack_public_path__ + "static/media/BetterMeter.a0f40566.svg";